import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Counter = ({ to, suffix = "", plain = false, duration = 2, testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const c = animate(plain ? to - 16 : 0, to, { duration, ease: "easeOut", onUpdate: (x) => setV(Math.round(x)) });
    return () => c.stop();
  }, [inView, to, duration, plain]);
  return (
    <span ref={ref} data-testid={testId}>
      {plain ? v : v.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
};

export const SectionHeading = ({ eyebrow, title, sub, center = false, dark = false }) => (
  <Reveal className={center ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    <div className={`inline-flex items-center gap-3 ${dark ? "text-gold-light" : "text-gold-ink"} text-xs sm:text-sm font-semibold tracking-[0.22em] uppercase ${center ? "justify-center" : ""}`}>
      <span className="h-px w-8 bg-gold" />
      {eyebrow}
    </div>
    <h2 className={`font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.15] ${dark ? "text-white" : "text-navy-900"}`}>{title}</h2>
    {sub && <p className={`mt-4 text-base md:text-lg ${dark ? "text-slate-300" : "text-slate-600"} ${center ? "mx-auto" : ""} max-w-2xl`}>{sub}</p>}
  </Reveal>
);
